<template>
  <header :class="componentClassName">
    <nav class="o-lp-global-header__nav">
      <div class="o-lp-global-header__branding">
        <a href="javascript:void(0);" @click="e => handleNavButtonClick(e, '#lp-brand-section')">
          <ul class="o-lp-global-header__nav-logo">
            <li>
              <img src="@/images/pages/landing/ntt-com-logo.svg" alt="NTT Communications" width="100" />
            </li>
            <li>
              <img src="@/images/cotoha-call-center-logo-horizontal.svg" alt="COTOHA Call Center" width="350" />
            </li>
          </ul>
        </a>
      </div>
      <ul class="o-lp-global-header__nav-items">
        <template v-for="(item, index) in navList" :key="index">
          <li :class="getNavItemClassName(item)">
            <a-button
              :variant="item.button ? 'block' : 'text'"
              :color="item.button ? 'primary' : null"
              :href="item.link"
              @click="e => handleNavButtonClick(e, item.link)"
            >
              {{ item.text }}
            </a-button>
          </li>
        </template>
      </ul>
    </nav>
  </header>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import AButton from '@/components/atoms/button';

export default {
  name: 'o-lp-global-header',
  components: {
    AButton,
  },
  props: {
    class: {
      type: String,
      default: '',
    },
    navList: {
      type: Array,
      default: new Array(0),
    },
    handleNavButtonClick: {
      type: Function,
      default: () => {},
    },
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('o-lp-global-header');
      return `${baseClassName} ${this.class}`.trim();
    },
  },
  methods: {
    getNavItemClassName(item) {
      return mapModifiers(
        'o-lp-global-header__nav-item',
        item.button ? 'app-button' : '',
        item.sp ? `sp-${item.sp}` : ''
      );
    },
  },
};
</script>
